import Vue from 'vue'
import Router from 'vue-router'

import login from '@/components/login'
import changePassWord from '@/components/changePassWord'
import register from '@/components/register'
import topNav from '@/components/topNav'
import index from '@/components/index'
import productIntroduction from '@/components/productIntroduction'
import updateNote from '@/components/updateNote'
import applyCase from '@/components/applyCase'

import videoList from '@/components/videoList'
import fileList from '@/components/fileList'
import aboutUs from '@/components/aboutUs'
import playVideo from '@/components/playVideo'
// import downLoad from '@/components/downLoad'

Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const router = new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'login',
    //   component: login
    // },
    // {
    //   path: '/sedpindex',
    //   name: 'login',
    //   component: login
    // },
    {
      path: '/playVideo',
      name: 'playVideo',
      component: playVideo
    },
    {
      path: '/',
      name: 'topNav',
      component: topNav,
      children:[
        {
          path: '/',
          name: 'index',
          component: index,

        },
        {
          path: '/index',
          name: 'index',
          component: index,

        },
        {
          path: '/productIntroduction',
          name: 'productIntroduction',
          component: productIntroduction,
        },
        {
          path: '/updateNote',
          name: 'updateNote',
          component: updateNote,
        },
        {
          path: '/applyCase',
          name: 'applyCase',
          component: applyCase,
        },
        {
          path: '/videoList',
          name: 'videoList',
          component: videoList
        },
        {
          path: '/fileList',
          name: 'fileList',
          component: fileList
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: aboutUs
        },



        {
          path: '/redirect/:path*',  // 匹配所有以/redirect开头的路径
          component: {
            beforeCreate() {
              const { params, query } = this.$route
              const { path } = params
              // 这里使用replace，避免在history中留下记录
              this.$router.replace({ path: '/' + (path || ''), query })
            },
            render: h => h() // 没有实际内容，只是执行重定向
          }
        },

      ]
    },


    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/changePassWord',
      name: 'changePassWord',
      component: changePassWord
    },


  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js